module.exports = __webpack_public_path__ + "static/media/9. Speaker Rolando B Victoria.a41d99f5.png";